<template>
  <div class="px-2">
    <last-comment-table-cell
      :lastComment="initiative.lastComment"
      v-if="isLastCommentCell"
      @open-event="$emit('open-comment-modal', { eventId: initiative.lastCommentId })"
      @add-comment="$emit('open-comment-modal', { focusAddCommentOnLoad: true })"
    />
    <template v-else-if="hasValue && isUserType">
      <user-short
        class="align-items-start"
        :hide-default-avatar="true"
        :show-tooltip-on-avatar="true"
        :length="22"
        :user-id="fieldValue"
      />
    </template>
    <template v-else>
      {{ fieldValue }}
    </template>
  </div>
</template>

<script>
import LastCommentTableCell from '@/components/initiative/LastCommentTableCell.vue'
import UserShort from '@/components/UserShort'
import { INITIATIVE_COMPUTED_FIELD_NAME, USER_TYPE_COMPUTED_FIELDS } from '@/constants/initiative'
import { getDaysAfter } from '@/utils/formatDate'
import { snakeCaseToCamelCaseString } from '@/utils/stringCase'
import * as R from 'ramda'

/**
 * This is the cell for computed fields in InitiativeRow. Computed fields are readonly fields
 */
export default {
  name: 'InitiativeComputedFieldCell',
  props: ['initiative', 'fieldName'],
  components: {
    UserShort,
    LastCommentTableCell
  },
  computed: {
    isLastCommentCell() {
      return this.fieldName === INITIATIVE_COMPUTED_FIELD_NAME.LAST_COMMENT
    },
    fieldValue() {
      const field = snakeCaseToCamelCaseString(this.fieldName)
      let value
      switch (this.fieldName) {
        case INITIATIVE_COMPUTED_FIELD_NAME.AGE:
          value = this.getDaysAfter(this.initiative.createdAt)
          break
        case INITIATIVE_COMPUTED_FIELD_NAME.DAYS_SINCE_LAST_UPDATE:
          value = this.getDaysAfter(this.initiative.updatedAt)
          break
        case INITIATIVE_COMPUTED_FIELD_NAME.TEAM:
          {
            const team = this.$store.getters.teamById(this.initiative.teamId)
            value = team?.name
          }
          break
        default:
          value = this.initiative[field]
      }
      if (this.fieldName === INITIATIVE_COMPUTED_FIELD_NAME.DUE_DATE_COUNT && !R.isNil(value)) {
        value += value > 1 ? ' Times' : ' Time'
      }
      return value
    },
    hasValue() {
      return !R.isNil(this.fieldValue)
    },
    isUserType() {
      return USER_TYPE_COMPUTED_FIELDS.includes(this.fieldName)
    }
  },
  methods: {
    getDaysAfter: getDaysAfter
  }
}
</script>

<style lang="scss" scoped></style>
